var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00841 6.45915L5.82643 9.64114C5.07327 10.3943 5.07327 11.6154 5.82643 12.3685V12.3685C6.57958 13.1217 7.80068 13.1217 8.55384 12.3685L13.7814 7.14101C15.1622 5.76022 15.1622 3.52153 13.7814 2.14075V2.14075C12.4006 0.75997 10.1619 0.75997 8.78112 2.14075L3.09901 7.82286C1.0906 9.83127 1.09061 13.0875 3.09901 15.096V15.096C5.10742 17.1044 8.3637 17.1044 10.3721 15.096L16.7361 8.732",
    stroke: "#0C0C0C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.4ff6f8741ae8c514a336179225dca5cd.svg";
export { ForwardRef as ReactComponent };